import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetFinancialStatement } from './useGetFinancialStatement'
import { FinancialStatementContent } from './FinancialStatementContent'

export const FinancialStatementComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetFinancialStatement(id, tileFilterSelections)

  return (
    <FinancialStatementContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function FinancialStatementComponentLoading() {
  return 'Loading...'
}
